import { render, staticRenderFns } from "./MenuCreateGroup.vue?vue&type=template&id=4d01f9e6&scoped=true"
import script from "./MenuCreateGroup.vue?vue&type=script&lang=js"
export * from "./MenuCreateGroup.vue?vue&type=script&lang=js"
import style0 from "./MenuCreateGroup.vue?vue&type=style&index=0&id=4d01f9e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d01f9e6",
  null
  
)

export default component.exports